module.exports = __webpack_public_path__ + "img/tianhong.4eb5f443.jpg";